import styled from "styled-components";
import React from "react";
import footerLogo from "./njaesLogo.svg";

const Styles = {
  FooterContainer: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: ${({ theme }) => theme.colors.grey1};
    // height: 11rem; // room for mobile nav bar
    a:link,
    a:visited,
    a:hover {
      color: black;
      text-decoration: none;
      font-size: 1em;
    }
    a:hover {
      text-decoration: underline;
    }
  `,
  WidthContainer: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    @media screen and (min-width: ${({ theme }) => theme.mobile}) {
      max-width: 1366px;
    }
  `,
  Header: styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 1rem 0.75rem;
    align-items: center;
    @media screen and (max-width: ${({ theme }) => theme.mobile}) {
      display: none;
    }
  `,
  Logo: styled.div`
  display: flex;
  justify-content: center;
    padding: 1rem;
    img {
      width: 13em;
    }
    @media screen and (max-width: ${({ theme }) => theme.mobile}) {
      display: none;
    }
  `,
  FooterMenuContainer: styled.div`
    display: flex;
    flex-wrap: wrap;
    border-bottom: 0.25px solid grey;
    justify-content: space-evenly;
  `,
  SingleMenu: styled.div`
    display: flex;
    flex-direction: column;
    padding: 1em;
    color: white;
    font-size: 0.75em;
    font-weight: 200;
    line-height: 4em;
    //   height: 400px;
    //   flex-wrap: wrap;
  `,
  Disclaimer: styled.div`
  width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    color: black;
    font-size: 0.75em;
    max-width: 800px;
  `,
};

const RutgersFooter = () => {
  return (
    <Styles.FooterContainer>
      <Styles.WidthContainer>
        <Styles.Logo>
          <a href="https://www.rutgers.edu">
            <img src={footerLogo} alt="Rutgers Logo" />
          </a>
        </Styles.Logo>
        <Styles.Disclaimer>
          <p>
            Developed By the Rutgers New Jersey Agricultural Experiment Station
            Office of Research Analytics.
          </p>
          <p>
            Rutgers, The State University of New Jersey is an equal access/equal
            opportunity institution. Individuals with disabilities are
            encouraged to direct suggestions, comments, or complaints concerning
            any accessibility issues with Rutgers websites to&nbsp;
            <a href="mailto:accessibility@rutgers.edu">
              accessibility@rutgers.edu
            </a>
            &nbsp;or complete the&nbsp;
            <a
              href="https://it.rutgers.edu/it-accessibility-initiative/barrierform/"
              target="_blank"
              rel="noreferrer"
            >
              Report Accessibility Barrier / Provide Feedback
            </a>
            &nbsp;form.
          </p>

          <p>
            {/* <a href="/copyright-information" target="_blank" rel="noreferrer"> */}
              Copyright &copy;{new Date().getFullYear()}
            {/* </a> */}
            , Rutgers, The State University of New Jersey. All rights
            reserved.&nbsp;
            <br />
            <a href="mailto:ora-it@njaes.rutgers.edu">Contact webmaster</a>
          </p>
        </Styles.Disclaimer>
      </Styles.WidthContainer>
    </Styles.FooterContainer>
  );
};

export default RutgersFooter;
